import styled from 'styled-components'

export const StepIndicator = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.space['8'],
  justifyContent: 'center',
}))

export const Step = styled.div<{ $isActive?: boolean; $isCompleted?: boolean }>(
  ({ theme, $isActive, $isCompleted }) => ({
    background: $isActive || $isCompleted ? theme.colors.black800 : theme.colors.gray400,
    borderRadius: theme.border.radius.circle,
    height: '1.2rem',
    transition: `background-color ${theme.transition.duration.md} ease`,
    width: '1.2rem',
  }),
)

export const Line = styled.div<{ $isActive?: boolean; $isCompleted?: boolean }>(
  ({ theme, $isActive, $isCompleted }) => ({
    background: $isCompleted
      ? theme.colors.black800
      : $isActive
        ? theme.colors.black100
        : theme.colors.gray400,
    height: '0.2rem',
    transition: `background-color ${theme.transition.duration.md} ease`,
    width: '10rem',
  }),
)
